export function parseCurrency(val?: string): string {
  if (!val) {
    return '';
  }
  let cheese: number = parseFloat(val);
  if (isNaN(cheese) || cheese === 0) {
    return '';
  }
  let cheeseString = val.toString();
  // parseFloat drops the "." on a number of "1." on Internet explorer, which doesnt allow you to place a decimal in the field
  // so we use the original "val" here instead of "cheese"
  const decIdx: number = cheeseString.indexOf('.');
  if (decIdx === -1) {
    return cheeseString;
  }
  if (cheeseString.length <= decIdx + 3) {
    return cheeseString;
  }
  return cheeseString.substr(0, decIdx + 3);
}

export function parsePhoneNumber(val: string | undefined): string {
  if (!val) {
    return '';
  }

  // if it is a valid phone num, we're done
  var temp = val.slice();
  val = val.replace(/-?\(?\)?/g, '');
  var isTenDigits = new RegExp('^[0-9]{10}$');
  var x = isTenDigits.test(val);

  if (x) {
    return val.substring(0, 3) + '-' + val.substring(3, 6) + '-' + val.substring(6);
  }

  var withCountryCode = new RegExp('^[0-9]{11}$');
  if (withCountryCode.test(val)) {
    return val.substring(0, 1) + '-' + val.substring(1, 4) + '-' + val.substring(4, 7) + '-' + val.substring(7);
  }
  return temp;
}



// WEBPACK FOOTER //
// ./src/common/parsers.ts